import { useRef, useState } from 'react'
import { AnimatePresence } from 'framer-motion'

import * as Styled from './styled'
import UserInfoBlock from './components/UserInfoBlock'
import MyProjectsBlock from './components/MyProjectsBlock'
import MoreBlock from './components/MoreBlock'
import UserAvatar from './components/UserAvatar'
import SignOutButton from './components/SignOutButton'
import useBackdropClick from 'hooks/useBackdropClick'
import ArrowDownIcon from 'assets/svgr-icons/Arrow_Down.svg'
import { useResponsive } from 'hooks/useResponsive'
import { UserDropdownLanguages } from './components/UserDropdownLanguages'
import { UserDropdownAspectRatio } from './components/UserDropdownAspectRatio'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

const UserDropdown = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const onClose = () => {
    setIsDropdownOpen(false)
  }
  const backdropRef = useBackdropClick<HTMLDivElement>(onClose, [
    '.user-dropdown-header',
    '.prompt-to-video-modal',
    '.prompt-to-video-modal-upload-message',
    '.prompt-to-video-modal-warning-popup',
    '.popup-content'
  ])
  const scrollableContentWrapperRef = useRef<null | HTMLDivElement>(null)

  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  return (
    <div ref={scrollableContentWrapperRef}>
      <Styled.UserDropdownHeader
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        $isDropdownOpen={isDropdownOpen}
        className="user-dropdown-header"
      >
        {!isMobile ? (
          <>
            <UserAvatar />
            <ArrowDownIcon />
          </>
        ) : (
          <Styled.BurgerButton
            className="burger-button"
            $isOpen={isDropdownOpen}
          >
            <div />
            <div />
          </Styled.BurgerButton>
        )}
      </Styled.UserDropdownHeader>

      <AnimatePresence>
        {/* TODOT: fix animation */}
        {isDropdownOpen && (
          <Styled.UserDropdownOverlay
          // {...OVERLAY_ANIMATION}
          >
            <Styled.UserDropdown
              isOpen={isDropdownOpen}
              ref={backdropRef}
              // {...(isMobile
              //   ? DROPDOWN_MOBILE_ANIMATION
              //   : DROPDOWN_DESKTOP_ANIMATION)}
            >
              <Styled.UserDropdownContent>
                <UserInfoBlock />
                {isMobile && (
                  <UserDropdownAspectRatio
                    scrollableContentWrapperRef={scrollableContentWrapperRef}
                  />
                )}
                <MyProjectsBlock />
                <MoreBlock />
                <UserDropdownLanguages
                  scrollableContentWrapperRef={scrollableContentWrapperRef}
                />
                <SignOutButton />
              </Styled.UserDropdownContent>
            </Styled.UserDropdown>
          </Styled.UserDropdownOverlay>
        )}
      </AnimatePresence>
    </div>
  )
}

export default UserDropdown
